//react
import React, { useState, useRef, useEffect } from 'react';
import '../css/carousel.scss';
import ArrowLeft from '../assets/image/slideimages/arrow-circle-left.svg';
import ArrowRight from '../assets/image/slideimages/arrow-circle-right.svg';
import {BiPlayCircle} from 'react-icons/bi'

function useTilt(animationDuration = '150ms') { 
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    // used to unify the touch and click cases
    const unify = (e) => (e.changedTouches ? e.changedTouches[0] : e);

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined,
    };

    let el = ref.current;

    const handleEnterEvent = () => {
      el.style.transition = `transform ${animationDuration} ease-out`;
    };

    const handleMoveEvent = (e) => {
      e.preventDefault();

      if (!el) {
        return;
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect();
      }
      state.mouseX = unify(e).clientX;
      state.mouseY = unify(e).clientY;

      const px = (state.mouseX - state.rect.left) / state.rect.width;
      const py = (state.mouseY - state.rect.top) / state.rect.height;

      el.style.setProperty('--px', px.toFixed(2));
      el.style.setProperty('--py', py.toFixed(2));
    };

    const handleEndEvent = () => {
      el.style.setProperty('--px', 0.5);
      el.style.setProperty('--py', 0.5);
      el.style.transition = `transform ${animationDuration} ease-in`;
    };

    el.addEventListener('mouseenter', handleEnterEvent);
    el.addEventListener('mousemove', handleMoveEvent);
    el.addEventListener('mouseleave', handleEndEvent);
    el.addEventListener('touchstart', handleEnterEvent);
    el.addEventListener('touchmove', handleMoveEvent);
    el.addEventListener('touchend', handleEndEvent);

    return () => {
      el.removeEventListener('mouseenter', handleEnterEvent);
      el.removeEventListener('mousemove', handleMoveEvent);
      el.removeEventListener('mouseleave', handleEndEvent);
      el.removeEventListener('touchstart', handleEnterEvent);
      el.removeEventListener('touchmove', handleMoveEvent);
      el.removeEventListener('touchend', handleEndEvent);
    };
  }, [animationDuration]);

  return ref;
}

const Slide = ({ image, title, subtitle, description, offset, isPageBackground }) => {
  const active = offset === 0 ? true : null,
    ref = useTilt(active);

  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        '--offset': offset,
        '--dir': offset === 0 ? 0 : offset > 0 ? 1 : -1,
      }}
    >
      <div
        // ref={ref}
        className="slideContent"
        style={{
          backgroundImage: `url('${image}')`,
        }}
      >
      </div>
    </div>
  );
};

const Carousel = ({ slides, isPageBackground }) => {
  const [slideIndex, setSlideIndex] = useState(slides.length*15);

  const handlePrevSlide = () => {
    setSlideIndex((prev) => (prev === 0 ? slides.length*30 - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setSlideIndex((prev) => (prev + 1) % (slides.length * 30));
  };

  return (
    <div>
        <div className="w-full absolute flex justify-between items-center h-full">
            <div className='z-[10] relative left-[calc(10%)] cursor-pointer' onClick={()=>{handlePrevSlide();}}>
                <img src={ArrowLeft}></img>
            </div>
            <BiPlayCircle className="text-white w-20 h-20 z-[10] relative cursor-pointer"></BiPlayCircle>
            <div className='z-[10] relative right-[calc(10%)] cursor-pointer' onClick={()=>{handleNextSlide();}}>
                <img src={ArrowRight}></img>
            </div>
        </div>
            <div className='w-[calc(100%+200px)] h-[150px] bg-black rounded-bl-[60%] rounded-br-[60%] absolute top-[-70px] left-[calc(-100px)] z-[7]'></div>
            <div className='w-[calc(100%+200px)] h-[150px] bg-black rounded-tl-[60%] rounded-tr-[60%] absolute top-[420px] left-[calc(-100px)] z-[7]'></div>
        <section className="slidesWrapper">
            <div className="slides">
                {[
                ...slides, ...slides, ...slides, ...slides,...slides, ...slides, ...slides, ...slides,
                ...slides, ...slides, ...slides, ...slides,...slides, ...slides, ...slides, ...slides,
                ...slides, ...slides, ...slides, ...slides,...slides, ...slides, ...slides, ...slides,
                ...slides, ...slides, ...slides, ...slides,...slides, ...slides, ...slides, ...slides
                ].map((slide, i) => {
                let offset = slides.length + (slideIndex - i);
                if (typeof slide === 'string') {
                    return (
                    <Slide image={slide} offset={offset} isPageBackground={isPageBackground} key={i} />
                    );
                } else {
                    return (
                    <Slide
                        image={slide.image}
                        title={slide.title}
                        subtitle={slide.subtitle}
                        description={slide.description}
                        offset={offset}
                        isPageBackground={false}
                        key={i}
                    />
                    );
                }
                })}
            </div>
        </section>
    </div>
  );
};

export default Carousel